import React from "react";
import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";

import AdresIcon from "./svg/AdresIcon";
import DoelgroepIcon from "./svg/DoelgroepIcon";
import DienInIcon from "./svg/DienInIcon";
import ExtraCommentaarIcon from "./svg/ExtraCommentaarIcon";
import IdentificatieIcon from "./svg/IdentificatieIcon";
import LinkIcon from "./svg/LinkIcon";
import OrganisatieIcon from "./svg/OrganisatieIcon";
import SocialeMediaIcon from "./svg/SocialeMediaIcon";
import SportinfrastructuurIcon from "./svg/SportinfrastructuurIcon";
import SporttakkenIcon from "./svg/SporttakkenIcon";
import TerugNaarOverzicht from "./svg/TerugNaarOverzicht";
import NiveauInstantieIcon from "./svg/NiveauInstantieIcon";

const TabNavIcon = (props) => {

    const { type, color } = props;

    let svgcontent = {
        [types.ICON_ORGANISATIE]: OrganisatieIcon,
        [types.ICON_IDENTIFICATIE]: IdentificatieIcon,
        [types.ICON_ADRES]: AdresIcon,
        [types.ICON_SPORTINFRASTRUCTUUR]: SportinfrastructuurIcon,
        [types.ICON_SPORTTAKKEN]: SporttakkenIcon,
        [types.ICON_DOELGROEP]: DoelgroepIcon,
        [types.ICON_SOCIALEMEDIA]: SocialeMediaIcon,
        [types.ICON_LINKS]: LinkIcon,
        [types.ICON_EXTRACOMMENTAAR]: ExtraCommentaarIcon,
        [types.ICON_DIENIN]: DienInIcon,
        [types.ICON_TERUGNAAROVERZICHT]: TerugNaarOverzicht,
        [types.ICON_NIVEAUINSTANTIE]: NiveauInstantieIcon
    };

    let svgpaths = svgcontent[types.ICON_SOCIALEMEDIA];
    if (type) {
        svgpaths = svgcontent[type] || svgcontent[types.ICON_SOCIALEMEDIA];
    }

    return (svgpaths(types.ICON_COLORS[color]));
};

TabNavIcon.propTypes = {
    type: PropTypes.string,
    color: PropTypes.string
};

export default TabNavIcon;